<template>
  <div>
    <title_header :title="headerTitle" />
    <div class="news_box">
      <div class="box_flex">
        <div class="box_left">
          <title_list_component
            :title="title"
            :titleList="titleList"
            @changeIndex="changeIndex"
          />
          <customer class="margin_top" :info="info" />
        </div>
        <div class="box_right">
          <div v-show="!showDetailBlock">
            <news_item
              v-for="item in tempList"
              :key="item.id"
              :news="item.schoolPageInfo"
              @showDetail="showDetail"
            />
            <el-pagination
              class="box_pagination"
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
              :total="list.length"
            >
            </el-pagination>
          </div>

          <news_content
            v-show="showDetailBlock"
            :contentDetail="contentDetail"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import title_header from "../../components/title_header";
import title_list_component from "../../components/title_list_component";
import customer from "../../components/customer";
import news_item from "../../components/content_item";
import news_content from "../../components/news_content";
export default {
  props: { info: Object },
  components: {
    title_header,
    title_list_component,
    customer,
    news_item,
    news_content,
  },
  data() {
    return {
      title: "企业新闻",
      headerTitle: "企业新闻",
      titleList: [{ name: "企业新闻" }, { name: "行业动态" }],
      contentDetail: {},
      showDetailBlock: false,
      index: 0,
      pageSize: 10,
      tempList: [],
      list: [],
      mixList: [],
    };
  },
  watch: {
    info: {
      handler() {
        this.initList();
      },
      deep: true,
    },
  },
  mounted() {
    this.initList();
  },
  methods: {
    initList() {
      let arr = [
        {
          name: "企业新闻",
          list: [],
        },
        {
          name: "行业动态",
          list: [],
        },
      ];
      if (this.info.wxSchoolPageItemList) {
        this.info.wxSchoolPageItemList.forEach((item) => {
          if (item.remark == "企业新闻") {
            if (item.isEmpty != 1) arr[0].list = arr[0].list.concat(item);
          } else {
            if (item.isEmpty != 1) arr[1].list = arr[1].list.concat(item);
          }
          if (item.schoolPageInfo.content) {
            item.schoolPageInfo.content = item.schoolPageInfo.content
              .replace(/<[^<>]+>/g, "")
              .replace(/&nbsp;/gi, "")
              .replace(/\s/g, "");
          }
        });
        this.mixList = arr;
        this.list = arr[0].list;
        this.init();
      } else {
        this.mixList = [];
        this.list = [];
        this.init();
      }
    },
    init() {
      let len = this.list.length;
      let start = 0;
      let end = this.pageSize - 1;
      if (this.list.length > end) {
        this.tempList = this.list.slice(start, len > end ? end : len);
      } else {
        this.tempList = this.list;
      }
    },
    // 切换分页
    handleCurrentChange(val) {
      let len = this.list.length;
      let start = (val - 1) * this.pageSize;
      let end = val * this.pageSize - 1;
      if (this.list) {
        this.tempList = this.list.slice(start, len > end ? end : len);
      } else {
        this.tempList = this.list;
      }
    },
    // 切换标题
    changeIndex(index) {
      this.showDetailBlock = false;
      this.headerTitle = this.mixList[index].name;
      this.list = this.mixList[index].list;
      this.init();
    },
    // 查看详情
    showDetail(detail) {
      this.showDetailBlock = true;
      this.contentDetail = detail;
    },
  },
};
</script>

<style lang="less" scoped>
.news_box {
  background-color: #ffffff;
  width: 1200px;
  margin: auto;
}

.box_flex {
  display: flex;
}

.margin_top {
  margin-top: 20px;
}

.box_left {
  padding: 10px;
  width: 300px !important;
  flex-shrink: 0;
}

.box_right {
  width: 100%;
  padding: 10px;
}

.box_pagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/module/module1/index.vue